export enum RefQueryValue {
    EXPIRED_SESSION = 'expired_session',
}
